module.exports = __webpack_public_path__ + "static/media/3.14.1d5370cd.png";